import { readCookie } from '../cookies';
export const XSRF_TOKEN_COOKIE_NAME = 'XSRF-TOKEN';
export const XSRF_HEADER_NAME = 'x-xsrf-token';
export function csrf() {
    const value = readCookie(XSRF_TOKEN_COOKIE_NAME);
    return { [XSRF_HEADER_NAME]: value };
}
//# sourceMappingURL=csrf.js.map